import { Observable } from 'rxjs';

import { Message } from 'domain/message/message';

import { ObserveMessagesQuery } from '../query/observe-messages.query';

export abstract class MessageRepositoryPort {
	public abstract observeMessages(
		query: ObserveMessagesQuery
	): Observable<Message[]>;

	public abstract saveMessages(messages: Message[]): Promise<void>;
}
